import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core';
import { Dashboard as DashboardLayout } from 'layouts';
import { connect } from "react-redux";

// Custom components
import {AccountsTable} from './components';

// Component styles
import styles from './styles';

class AccountManager extends Component {
  render() {
    const { classes } = this.props;
    return (
      <DashboardLayout title="Account Manager">
        <div className={classes.root}>
          <div className={classes.content}>
            <AccountsTable/>
          </div>
        </div>
      </DashboardLayout>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
});

AccountManager.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(AccountManager);
